import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import TrackedButton from '../Buttons/TrackedButton';

const propTypes = {
  providers: PropTypes.array
};

const defaultProps = {
  providers: null
};

class SocialProviders extends React.Component {

  render() {

    const { providers, socialLogin } = this.props;
    if (!providers) {
      return null;
    }

    return (
      <div>
        {
          providers.map( (provider, index) => {
            return (
              <TrackedButton
                key={index}
                className={provider + ' text-uppercase socialLogin-btn u-font-foundation-regular u-textSize-18 text-center'}
                onClick={() => socialLogin(provider)}
                title={_.capitalize(provider)}
                action={`Click on ${_.capitalize(provider)} in Join modal`}
                gaAction={`Click on '${_.capitalize(provider)}' in Join modal`}
                value={25}
              >
                <span className="provider-name">{_.capitalize(provider)}</span>
              </TrackedButton>
            );
          })
        }
      </div>
    );
  }

}

SocialProviders.propTypes = propTypes;
SocialProviders.defaultProps = defaultProps;

export default SocialProviders;
